import CompanyManagementPage from './index.vue'
export {CompanyManagementPage}
export default CompanyManagementPage

